import { render, staticRenderFns } from "./Dnepr.vue?vue&type=template&id=768b90b9"
import script from "./Dnepr.vue?vue&type=script&lang=js"
export * from "./Dnepr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports